import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { RECEIVED_STATUS } from 'domains/merchant-inbound/constants'


const propTypes = {
  received_status: PropTypes.string.isRequired
}

/**
 * It maps `received status` to certain style and pass to `StatusBadge`.
 * @param {string} received_status Merchant Inbound received status. available values
 * - `pending`
 * - `canceled`
 * - `received`
 */
const MerchantInboundReceivedStatusBadge = ({ received_status }) => {

  const colorMap = {
    [RECEIVED_STATUS.RECEIVED] : 'success',
    [RECEIVED_STATUS.PENDING]  : 'info',
    [RECEIVED_STATUS.CANCELED] : 'danger'
  }

  const color = colorMap[received_status] || 'default'

  return <StatusBadge color={ color } label={ received_status } />
}

MerchantInboundReceivedStatusBadge.propTypes = propTypes

export default MerchantInboundReceivedStatusBadge